// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import UsageStackItem from '../components/usage/UsageStackItem';


class UsageStack extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSubArea: -1
    };
  }

  render() {
    const {
      area,
      subAreas,
      useQuestions,
      valueRealized,
      dsaUseQuestions,
      dsaValueRealized,
      answerDSAUseQuestion,
      answerDSAValueRealized
    } = this.props;

    const {selectedSubArea} = this.state;
    const subareas = subAreas
      .filter(sa => sa.area === area.id)
      .sort((a, b) => a.order - b.order);
    const toggleSubArea = sa => {
      this.setState({
        selectedSubArea: (selectedSubArea !== sa) ? sa : -1
      });
    };

    return (
      <div className='usage-stack'>
        {
          subareas && subareas.map(subarea =>
            (<UsageStackItem key={subarea.id}
              active={selectedSubArea === subarea.id}
              area={area}
              subarea={subarea}
              useQuestions={useQuestions}
              dsaUseQuestions={dsaUseQuestions}
              answerDSAUseQuestion={answerDSAUseQuestion}
              valueRealized={valueRealized}
              dsaValueRealized={dsaValueRealized}
              answerDSAValueRealized={answerDSAValueRealized}
              toggleSubArea={toggleSubArea}
            />)
          )
        }
      </div>
    );
  }
}

UsageStack.propTypes = {
  area: PropTypes.object,
  subAreas: PropTypes.array,
  useQuestions: PropTypes.array,
  dsaUseQuestions: PropTypes.array,
  answerDSAUseQuestion: PropTypes.func,
  valueRealized: PropTypes.array,
  dsaValueRealized: PropTypes.array,
  answerDSAValueRealized: PropTypes.func
};

export default UsageStack;



// WEBPACK FOOTER //
// ./src/containers/UsageStack.js